import { connect } from "react-redux";
import { browserHistory } from "react-router";
import appPath from "utils/appPath";
import userActions from "ducks/user";
import User from "services/User";
import loginActions from "ducks/loginRegister";
import marketingActions from "ducks/marketing";
import { SCREENS, ELOQUA_LEAD_SOURCE_VALUES } from "common/constants/Constants";
import { setThinking, doneThinking } from "ducks/thinking";
import { redirectIfTerminalUser } from "./RegistrationSignInContainer";
import { getReferralParams } from "utils/getSubscriptionReferralParams";
import { hasBulkSubsRedirectTo } from "utils/bulkSubscriptionUtils";

export function createMapStateToProps() {
    return (state, ownProps) => {
        const { loginRegister = {}, thinking } = state;
        const referral = getReferralParams(ownProps.location.query) || {};

        const hasBulkSubsRedirect = hasBulkSubsRedirectTo(ownProps.location.query);

        return {
            thinking,
            email: referral.subscriptionEmail || loginRegister.email || "",
            confirmationEmail: loginRegister.confirmationEmail,
            subscriptionId: referral.subscriptionId || loginRegister.subscriptionId || "",
            provider: referral.provider || loginRegister.provider || "",
            subscriptionType: referral.type || loginRegister.subscriptionType || "",
            product: referral.product || "BW",
            bloombergSiteUrl: state.config.bloombergSiteUrl,
            grecaptchaApiKey: state.config.grecaptchaApiKey,
            errors: loginRegister.errors,
            useRecaptcha: loginRegister.useRecaptcha,
            signInLink: appPath.withIframePrefix(SCREENS.SIGN_IN),
            showAlertModal: loginRegister.showAlertModal,
            hasBulkSubsRedirect
        };
    };
}

export function mapDispatchToProps(dispatch, ownProps) {
    return {
        checkUser() {
            if (User.hasUserToken()) {
                return User.fetchUser()
                    .then((user) => dispatch(loginActions.redirectAfterCheckUser(user)));
            }

            const {
                subscriptionEmail,
                subscriptionId,
                region,
                postalCode
            } = getReferralParams(ownProps.location.query) || {};

            if (subscriptionEmail) {
                dispatch(loginActions.emailChange(subscriptionEmail));
            }

            if (subscriptionId) {
                dispatch(loginActions.setAccountId(subscriptionId));
            }

            if (region) {
                dispatch(loginActions.setRegion(region));
            }

            if (postalCode) {
                dispatch(loginActions.setPostalCode(postalCode));
            }
        },

        socialLogin(socialSite) {
            dispatch(setThinking());

            return dispatch(loginActions.socialLogin(socialSite))
                .then((loginDetails) => {
                    if (loginDetails.newSocialLogin) {
                        dispatch(marketingActions.sendEmailToEloquaAndCpref(
                            loginDetails.socialEmail, ELOQUA_LEAD_SOURCE_VALUES.SOCIAL_LOGIN));
                    }

                    return loginDetails;
                })
                .then(() => dispatch(userActions.startFetchingUser()))
                .then(redirectIfTerminalUser(socialSite))
                .then(() => dispatch(loginActions.redirectAfterSignIn()))
                .then(() => dispatch(doneThinking()))
                .catch((error) => {
                    dispatch(doneThinking());

                    if (error.status === 401) {
                        browserHistory.push(appPath(SCREENS.REGISTER));
                    }
                });
        },

        onEmailChange(newEmail) {
            return dispatch(loginActions.emailChange(newEmail));
        },

        onAccountIdChange(newAccountId) {
            return dispatch(loginActions.accountIdChange(newAccountId));
        },

        onConfirmationEmailChange(confirmationEmail) {
            return dispatch(loginActions.confirmationEmailChange(confirmationEmail));
        },

        onSubmit(email, captcha) {
            dispatch(loginActions.clearError("register"));
            dispatch(setThinking());

            return dispatch(marketingActions.sendEmailToEloquaAndCpref(
                email,
                ownProps.location.query.closeable === "false"
                    ? ELOQUA_LEAD_SOURCE_VALUES.REGISTRATION_REG_WALL
                    : ELOQUA_LEAD_SOURCE_VALUES.REGISTRATION_REGULAR,
                true
            ))
                .catch(() => { /* do nothing */ })
                .then(() => {
                    dispatch(loginActions.register(email, captcha, ownProps.location.query.redirectTo));
                    browserHistory.push(appPath.withIframePrefix(SCREENS.ACTIVATION_EMAIL));
                })
                .then(() => dispatch(doneThinking()))
                .catch(() => dispatch(doneThinking()));
        },

        onBusinessweekSubmit({ email, subscription }) {
            return dispatch(loginActions.registerBusinessweek(email, subscription))
                .then(() => browserHistory.push(appPath(SCREENS.ACTIVATION_EMAIL)));
        },

        closeModal() {
            dispatch(loginActions.hideAlertModal());
        }
    };
}

function createRegistrationContainer(component) {
    return connect(
        createMapStateToProps(),
        mapDispatchToProps
    )(component);
}

export default createRegistrationContainer;
